export default {
    mounted() {
        this.loadScript();
        /*if (this.getIframe && this.getIframe.search("<script") >= 0 && this.getScriptUrl) {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', this.getScriptUrl)
            document.head.appendChild(recaptchaScript)
        }*/
    },
    methods: {
        loadScript() {
            if (this.getIframe && this.getIframe.search("<script") >= 0 && this.getScriptUrl) {
                let recaptchaScript = document.createElement('script')
                console.log("this.getScriptUrl",this.getScriptUrl);
                recaptchaScript.setAttribute('src', this.getScriptUrl)
                document.head.appendChild(recaptchaScript);
                return true;
            }
            return false;
        }
    },
    computed: {
        getScriptUrl() {
            let template = document.createElement('template');
            template.innerHTML = this.getIframe;

            if (template.content.childNodes && template.content.childNodes.length > 0) {
                return template.content.childNodes[0].src;
            }
            return null;
        },
        isMobile() {
            return this.$device.mobile();
        },
        getIframe() {
            let ad = this.adData ? this.adData : this.ad;

            if (!ad) {
                return null;
            }
            if (this.isMobile && ad.mobile_iframe) {
                return ad.mobile_iframe;
            }
            if (!this.isMobile && ad.iframe_code) {
                return ad.iframe_code;
            }
        },
    }
}